import { useEffect, useRef } from 'react'

type TurnstileApi = { render: (element: HTMLElement, options: { sitekey: string; callback: (token: string) => void; 'expired-callback': () => void; 'error-callback': () => void }) => void }

declare global { interface Window { turnstile?: TurnstileApi } }

type Props = { onToken: (token: string) => void; onUnavailable: () => void }

export function Turnstile({ onToken, onUnavailable }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const sitekey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined
    if (!sitekey || !ref.current) { onUnavailable(); return }
    const render = () => {
      if (window.turnstile && ref.current) {
        window.turnstile.render(ref.current, {
          sitekey,
          callback: onToken,
          'expired-callback': () => { onToken(''); onUnavailable() },
          'error-callback': () => { onToken(''); onUnavailable() },
        })
      } else onUnavailable()
    }
    if (window.turnstile) render()
    else {
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true
      script.defer = true
      script.onload = render
      script.onerror = onUnavailable
      document.head.appendChild(script)
    }
    return () => { onToken('') }
  }, [onToken, onUnavailable])
  return <div ref={ref} role="group" aria-label="Security check" />
}
